import style from './TitleBar.module.scss'

interface TitleBarProps {
  infoComponent: React.ReactNode
  buttonComponent: React.ReactNode
}

const TitleBar = ({ infoComponent, buttonComponent }: TitleBarProps) => {
  return (
    <div className={style['title-bar']}>
      {infoComponent}
      <div className={style['title-bar-rightmost-pos']}>
        <div className={style['title-bar-center-alignment']}>{buttonComponent}</div>
      </div>
    </div>
  )
}

export default TitleBar
